export const profile = {
  name: "Siva Sakthi Velan R",
  shortName: "Siva",
  title: "Data & AI/ML Architect",
  subtitle: "Delivery & Solutioning Leader",
  location: "Chennai, India",
  yearsExp: "13+",
  email: "moa_sakthi@live.in",
  phone: "+91 9884 176193",
  linkedin: "https://www.linkedin.com/in/sivasakthivelan/",
  summary:
    "I architect enterprise-scale Data, AI/ML and GenAI platforms end-to-end — from pre-sales solutioning and RFP wins to production delivery. 35+ enterprise projects, $8M+ pipeline influenced, and platforms scaling to 1PB data lakes and 1M+ events/sec.",
  taglines: [
    "I architect enterprise AI systems that ship.",
    "13+ years turning data into decisions.",
    "GenAI · Agentic AI · Data Platforms.",
    "From RFP whiteboard to 1PB production.",
    "Let's build something intelligent."
  ]
};

export const stats = [
  { label: "Years Experience", value: 13, suffix: "+" },
  { label: "Enterprise Projects", value: 35, suffix: "+" },
  { label: "Revenue Pipeline", value: 8, suffix: "M+", prefix: "$" },
  { label: "Data Lake Scale", value: 1, suffix: "PB" },
  { label: "Events / second", value: 1, suffix: "M+" },
  { label: "Engineers Led", value: 30, suffix: "+" }
];

export const skills = [
  {
    group: "AI / ML & GenAI",
    color: "primary",
    items: [
      "LLM Architecture", "RAG Systems", "Vector DBs (FAISS/Pinecone/OpenSearch)",
      "Prompt Engineering", "AWS Bedrock", "SageMaker Pipelines",
      "MLflow", "Kubeflow", "MLOps", "Feature Engineering",
      "Agentic Workflows", "LangChain"
    ]
  },
  {
    group: "Data Engineering",
    color: "accent",
    items: [
      "Data Lakes & Data Mesh", "PySpark", "Spark SQL",
      "Streaming ETL", "Batch ETL", "Data Warehousing",
      "Metadata & Lineage", "Data Quality", "Airflow", "NiFi"
    ]
  },
  {
    group: "Cloud & AWS",
    color: "secondary",
    items: [
      "S3", "EMR", "Glue", "Lake Formation", "Athena", "Redshift",
      "Kinesis", "Step Functions", "MWAA", "SageMaker", "Bedrock",
      "Lambda", "API Gateway", "ECS/EKS"
    ]
  },
  {
    group: "Big Data & OSS",
    color: "primary",
    items: ["Apache Spark", "Hadoop", "Kafka", "NiFi", "Airflow",
      "Trino/Presto", "Hive", "HDFS", "Superset"]
  },
  {
    group: "Programming",
    color: "accent",
    items: ["Python", "SQL (Advanced)", "Java", "Scala", "R", "JavaScript"]
  },
  {
    group: "Solutioning & Delivery",
    color: "secondary",
    items: [
      "RFP / RFQ Ownership", "HLD & LLD", "Cost Estimation",
      "Client Workshops", "Pre-Sales Demos", "Architecture Governance",
      "Agile Delivery", "Team Leadership"
    ]
  }
];

export const experience = [
  {
    company: "CloudHub",
    role: "Delivery Manager",
    period: "Oct 2023 — Present",
    location: "India",
    tag: "Enterprise Solutioning · Presales · Delivery",
    highlights: [
      "Led 15+ RFP/RFQ responses owning architecture, sizing and cost modelling.",
      "Contributed $4M+ new revenue through solution enablement and rapid PoCs.",
      "Directed delivery of 13+ enterprise Data & AI transformation programs.",
      "Managed 30+ engineers across Data, ML, DevOps and Cloud.",
      "Designed Bedrock + RAG LLM chatbot platforms and SageMaker MLOps pipelines."
    ]
  },
  {
    company: "GainInsights Solutions",
    role: "Lead Data Architect / Senior Delivery Engineer",
    period: "Jan 2016 — Oct 2023",
    location: "India",
    tag: "Data Platforms · ML · Cloud Migration",
    highlights: [
      "Architected Data Lakes scaling to 1 PB and real-time streams processing 1M+ events/sec.",
      "Delivered 20+ enterprise data programs contributing $3M+ revenue.",
      "Migrated on-prem Hadoop clusters to AWS & GCP; cut BigQuery cost by 30%.",
      "Improved data performance by 40% via storage and query optimisation.",
      "Won Employee of the Year & Technology Excellence Award."
    ]
  },
  {
    company: "Mobiveil",
    role: "Python Developer",
    period: "May 2014 — Dec 2015",
    location: "India",
    tag: "Backend · APIs · Early Big Data",
    highlights: [
      "Built REST APIs and workflow automations across Python and Java stacks.",
      "Tuned PySpark pipelines for 20% faster processing.",
      "Migrated HDFS workloads to Amazon S3 — 60% infra cost saving.",
      "Optimised Snowflake SQL workflows for 25% compute cost reduction."
    ]
  },
  {
    company: "Redposh Private Limited",
    role: "Web Developer",
    period: "May 2013 — Apr 2014",
    location: "India",
    tag: "Web · WordPress · UI",
    highlights: [
      "Designed and deployed 200+ WordPress sites with custom themes & plugins.",
      "Delivered responsive UI, strong security posture and SEO-optimised architectures."
    ]
  }
];

export const projects = [
  // REAL projects from resume
  {
    kind: "real",
    title: "Industry GenAI Sandbox — RAG Chatbots",
    tag: "GenAI · RAG · LLM",
    image: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Domain-specific RAG chatbots on AWS Bedrock + Anthropic with vector search, grounding, prompt engineering and enterprise security.",
    stack: ["AWS Bedrock", "Anthropic", "LangChain", "OpenSearch", "SageMaker", "Python"],
    impact: ["Enterprise-grade RAG", "Multi-tenant grounding"]
  },
  {
    kind: "real",
    title: "Car Damage Detection",
    tag: "Computer Vision · MLOps",
    image: "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Automated detection & classification of vehicle damage using CNN models with an end-to-end MLOps pipeline.",
    stack: ["SageMaker", "TensorFlow", "OpenCV", "Python"],
    impact: ["Auto claims triage", "Reduced manual review"]
  },
  {
    kind: "real",
    title: "Telecom 1 PB Data Lake",
    tag: "Data Lake · Analytics",
    image: "https://images.unsplash.com/photo-1727434032773-af3cd98375ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "End-to-end analytics platform with multi-layer architecture serving Telecom scale data (1 PB+) with sub-second query latency.",
    stack: ["Hadoop", "Spark", "Presto", "AWS", "QlikSense"],
    impact: ["1 PB scale", "40% faster queries"]
  },
  {
    kind: "real",
    title: "Solar Predictive Maintenance",
    tag: "Time-Series ML",
    image: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Forecasted fleet performance anomalies, automated ticketing and alerting workflows across a distributed solar fleet.",
    stack: ["Python", "Prophet", "XGBoost", "SageMaker"],
    impact: ["Downtime reduction", "Automated tickets"]
  },
  {
    kind: "real",
    title: "Contact Centre Intelligence",
    tag: "GenAI · Speech",
    image: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Automated voice-call analytics with intent detection, sentiment scoring and dynamic response generation.",
    stack: ["AWS Bedrock", "Transcribe", "OpenSearch", "Python"],
    impact: ["Auto-QA calls", "Faster intent routing"]
  },
  {
    kind: "real",
    title: "FinOps Cost Optimisation Platform",
    tag: "GenAI · FinOps",
    image: "https://images.unsplash.com/photo-1727434032773-af3cd98375ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "LLM-assisted insights plus dashboards that reduced cloud spend by 25 – 35% across multiple AWS accounts.",
    stack: ["Python", "AWS Bedrock", "Lambda", "QuickSight"],
    impact: ["25–35% cloud savings", "Executive dashboards"]
  },
  // FICTIONAL showcase projects — clearly labelled
  {
    kind: "lab",
    title: "Agentic Research Assistant",
    tag: "Agentic AI · LangGraph",
    image: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Multi-agent research copilot that plans, browses, cites and synthesises answers with self-critique loops and tool routing.",
    stack: ["LangGraph", "Claude Sonnet", "Tavily", "Redis", "FastAPI"],
    impact: ["Autonomous multi-step research", "Cited outputs"]
  },
  {
    kind: "lab",
    title: "RAG-Powered Resume Matcher",
    tag: "GenAI · HR-Tech",
    image: "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Vector-search + rerank pipeline that scores résumés against JDs with explainable evidence spans and bias auditing.",
    stack: ["Bedrock", "OpenSearch", "Reranker", "Streamlit"],
    impact: ["Explainable scoring", "Bias flags"]
  },
  {
    kind: "lab",
    title: "Multi-Agent Data Analyst",
    tag: "Agentic AI · Analytics",
    image: "https://images.unsplash.com/photo-1727434032773-af3cd98375ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Agent swarm — Planner, SQL, Chart, Critic — turns natural-language questions into governed SQL, plots and narrative summaries.",
    stack: ["CrewAI", "DuckDB", "Vega-Lite", "OpenAI GPT"],
    impact: ["NL → SQL → Insight", "Self-verifying agents"]
  },
  {
    kind: "lab",
    title: "LLM-Powered Legacy Code Migrator",
    tag: "GenAI · DevX",
    image: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Refactors legacy JSP/Spring modules to React + Spring Boot microservices with test generation and diff review workflows.",
    stack: ["Claude", "TreeSitter", "PyTest", "GitHub Actions"],
    impact: ["Faster modernisation", "Automated tests"]
  }
];

export const achievements = [
  "Employee of the Year & Technology Excellence Award — GainInsights",
  "Zero-data-loss enterprise platforms with 90%+ data quality",
  "15+ CXO-level client workshops & PoCs delivered",
  "Recognised in 10+ hackathons & innovation programs",
  "Designed & maintained 80+ production Airflow DAGs"
];

export const education = [
  { degree: "M.Sc Computer Science", school: "Vels University, Chennai", period: "2011 — 2013" },
  { degree: "BCA", school: "Shree Chandraprabhu Jain College, Chennai", period: "2007 — 2010" }
];